import { Injectable } from '@angular/core'
import { RestService } from './rest/rest.service'
import { Likeable } from '@interface/likeable';
import { SentryService } from '@service/sentry.service';
import { LikeableTypeConfigService } from '@service/likeable-type-config.service';
import { LikeableTypeConfig } from '@model/likeable-type-config';

@Injectable({
  providedIn: 'root',
})
export class LikeService {

  constructor(
    private restService: RestService,
    private sentryService: SentryService,
    private likeableTypeConfigService: LikeableTypeConfigService,
  ) {}

  // public get(likeable: Likeable): void {
  //   this.restService.post('likes/get',this.getRestData(likeable))
  //   .catch(err=>this.sentryService.silentCaptureException(err))
  // }

  public delete(l:Likeable):void {
    this.restService.delete('likes/remove',this.getRestData(l))
  }

  public add(l:Likeable):void {
    this.restService.post('likes/add', this.getRestData(l))
  }

  private getRestData(l:Likeable){

    let config: LikeableTypeConfig = this.likeableTypeConfigService.getConfigByLikeable(l)

    return {
      model: config.identifier,
      model_id: l.id
    }
  }
}
